import React from 'react';
import styled from '../../../libs/styled.es.js';
import { SvgIcon } from '../../atoms/SvgIcon/SvgIcon.es.js';
import { Button } from '../../atoms/Button/Button.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getTransform = (props) => {
  let style = "";
  switch (props.direction) {
    case "right":
      style = "transform: rotate(90deg)";
      break;
    case "down":
      style = "transform: rotate(180deg)";
      break;
    case "left":
      style = "transform: rotate(-90deg)";
      break;
  }
  return style;
};
const StyledIcon = styled(SvgIcon)((props) => `
  transition: transform .2s ease-in-out;
  ${getTransform(props)};
  position: relative;
  margin-left: 2px;
`);
const StyledButton = styled(Button)`
  display: flex;
`;
const Text = styled.span`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
`;
const ButtonChevron = (_a) => {
  var _b = _a, {
    children,
    direction,
    showArrow = true
  } = _b, props = __objRest(_b, [
    "children",
    "direction",
    "showArrow"
  ]);
  return /* @__PURE__ */ React.createElement(StyledButton, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Text, null, children), showArrow && /* @__PURE__ */ React.createElement(StyledIcon, {
    direction,
    name: "chevron-up",
    size: 12
  }));
};

export { ButtonChevron };
